import { combineReducers } from 'redux';
import {
  FETCH_REQUIREMENTS,
  FETCH_REQUIREMENTS_SUCCESS,
  FETCH_CONTACTS_SUCCESS,
  FETCH_CONTACTS,
} from '../actions/requirements';
import { ADD_SITE } from '../actions/sites';

const requirementReducer = field => {
  return (state = [], action) => {
    switch (action.type) {
      case FETCH_REQUIREMENTS_SUCCESS:
        return action[field];
      default:
        return state;
    }
  };
};

const isNew = requirementReducer('isNew');
const workers = requirementReducer('workers');
const products = requirementReducer('products');
const units = requirementReducer('units');
const securityEpis = requirementReducer('securityEpis');
const inventoryToPlan = requirementReducer('inventoryToPlan');

const contacts = (state = [], action) => {
  switch (action.type) {
    case FETCH_REQUIREMENTS_SUCCESS:
      return action['contacts'];
    case FETCH_CONTACTS_SUCCESS:
      return action['contacts'];
    default:
      return state;
  }
};

// Sites is a specific one as they could be added from UI
const sites = (state = [], action) => {
  switch (action.type) {
    case FETCH_REQUIREMENTS_SUCCESS:
      return action['sites'];
    case ADD_SITE:
      return [...state, action.site];
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_REQUIREMENTS:
    case FETCH_CONTACTS:
      return true;
    case FETCH_REQUIREMENTS_SUCCESS:
    case FETCH_CONTACTS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const requirements = combineReducers({
  isNew,
  workers,
  contacts,
  sites,
  products,
  units,
  securityEpis,
  inventoryToPlan,
  isFetching,
});

export default requirements;

export const getAllSites = state => state.siteCase.requirements.sites;
export const getAllWorkers = state => state.siteCase.requirements.workers;
export const getAllContacts = state => state.siteCase.requirements.contacts;
export const getAllProducts = state => state.siteCase.requirements.products;
export const getAllUnits = state => state.siteCase.requirements.units;
export const getAllSecurityEpis = state =>
  state.siteCase.requirements.securityEpis;
export const getAllInventoryToPlan = state =>
  state.siteCase.requirements.inventoryToPlan;
export const getCaseNewStatus = state => state.siteCase.requirements.isNew;

export const getIsFetching = state => state.siteCase.requirements.isFetching;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/reducers/requirements.js